<template>
    <div class="vx-spoiler relative">
        <div
            class="absolute w-full h-full spoiler-overlay"
            :style="styles"
            :class="{ shown: revealed }"
            @click="revealed = !revealed"
        >
            <div class="h-full w-full relative p-2">
                <slot name="overlay">
                    <div class="flex justify-center items-center h-full w-full">
                        <span v-if="!revealed">Reveal</span>
                    </div>
                </slot>
            </div>
        </div>
        <slot></slot>
    </div>
</template>

<script>
import _color from '@/assets/utils/color.js'

export default {
    name: 'vx-spoiler',
    props: {
        color: {
            type: String,
            default: 'danger'
        }
    },
    data() {
        return {
            revealed: false
        }
    },
    watch: {
        revealed: {
            handler(newV) {
                this.$emit('revealed')
            }
        }
    },
    computed: {
        color_x() {
            return _color.getColorString(this.color)
        },
        styles() {
            return {
                'background-Color': this.color_x
            }
        }
    },
    methods: {},
    mounted() {},
    created() {}
}
</script>

<style lang="scss" scoped>
.spoiler-overlay {
    border-radius: 5px;
    transition: all 0.2s ease;
    cursor: pointer;
    & > * {
        opacity: 0;
        transition: all 0.2s ease;
    }
    &:hover > * {
        opacity: 1;
    }
    &.shown {
        opacity: 0.2;
        pointer-events: none;
    }
}
.icon {
    position: absolute !important;
    top: 5px;
    right: 5px;
}
</style>
